import { render, staticRenderFns } from "./BillingPlanDetailsPage.vue?vue&type=template&id=6bbaa318&scoped=true&"
import script from "./BillingPlanDetailsPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillingPlanDetailsPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BillingPlanDetailsPage.vue?vue&type=style&index=0&id=6bbaa318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbaa318",
  null
  
)

export default component.exports